import {authorize, IWithRouterProps, withRouter} from "@athena-portal/components";
import * as React from "react";
import {PluginTemplates} from "../../../../../utils/PluginTemplates";
import { scrollToTop, setSessionStorage } from "../../../../../CommonFunctions";
import {
    FalconNavigatorHeader,
    CLAIM_TYPE_HOME,
    CLAIM_TYPE_OTHER,
    NEW_CLAIM
} from "@falcon/services";
import FalconHeader from "../../../../../components/navigation/FalconHeader";
import FalconFooter from "../../../../../components/navigation/FalconFooter";
import {ButtonLink} from "../../../../../components/navigation/ButtonLink";
import {AllianzOnlineBadge} from "../../../../../components/AllianzOnlineBadge";

interface IPageParams {
    policyNumber: string;
    [key: string]: string | undefined;
}

interface IState {
    link: string,
    claimTypeChecked: string,
}

@authorize
export class PickAnnualHomeClaimKindPagePlain extends React.Component<IWithRouterProps<IPageParams>, IState> {
    private pluginTemplates = new PluginTemplates();

    private claimTypes = new Map<string, string>([
        [CLAIM_TYPE_HOME, "Home Emergency"],
        [CLAIM_TYPE_OTHER, "All other claims (theft from the property, accidental damage, etc)"]
    ]);

    constructor(props: IWithRouterProps<IPageParams>) {
        super(props);
        this.state = {
            link: "",
            claimTypeChecked: "",
        };
    }

    public componentDidMount(): void {
        scrollToTop();
        this.pluginTemplates.setPageTitle("Make a claim");
    }

    public render(): React.ReactNode {
        const backLinkUrl: string = `/dashboard/annualHome/${this.props.params.policyNumber}`;

        return (
            <React.Fragment>
                <FalconHeader/>
                <div className="page-contents plugin claims">
                    <AllianzOnlineBadge/>
                    <FalconNavigatorHeader back={backLinkUrl} title="Make a claim"/>
                    <div>
                        <div className="page-contents">
                            {this.renderClaimRadioButtons(this.claimTypes)}
                        </div>
                        <div className="px-4 px-md-0 ml-md-19 padding-0">
                            <ButtonLink to={this.state.link} primary={true} routeState={{prevPath: location.pathname}}
                                        disabled={this.state.link === ""}
                                        className={"float-right-desktop"}> Next </ButtonLink>
                        </div>
                    </div>
                    {this.pluginTemplates.renderBackLink("Back", false, backLinkUrl)}
                </div>
                <FalconFooter/>
            </React.Fragment>
        );
    }

    private handleOnChangeEvent = (event: any): void => {
        const value = event.currentTarget.value;

        if (this.claimTypes.has(value)) {
            this.setState({
                claimTypeChecked: value,
                link: `/dashboard/annualHome/${this.props.params.policyNumber}/claims/details`
            });
            setSessionStorage("claim", value);
            setSessionStorage("referrerJourney", NEW_CLAIM);
        }
    };

    private renderClaimRadioButtons(claimTypes: Map<string, string>): React.ReactNode {

        const radioButtons: React.ReactNode[] = [];
        claimTypes.forEach((value, key) =>
            radioButtons.push(
                <div key={key} className="custom-control mt-2 ml-2 mb-3">
                    <input
                        className={"custom-radiobutton cursor-pointer"}
                        type="radio"
                        name={key + "-claim"}
                        id={key + "-claim"}
                        value={key}
                        checked={this.state.claimTypeChecked === key}
                        onChange={this.handleOnChangeEvent}
                    />
                    <label id={'claim-type-label'} className="checkbox-label label-bg-transparent"
                           htmlFor={key + "-claim"}>
                        {value}
                    </label>
                </div>)
        );
        return (
            <div className="panel margin-top-30 padding-top-10">
                <p className="font-weight-semi-bold">Please choose what type of claim you want to make?</p>
                <div>{radioButtons}</div>
            </div>
        );
    }
}

export const PickAnnualHomeClaimKindPage = withRouter<{}, IPageParams>(PickAnnualHomeClaimKindPagePlain)
